var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "900px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _vm.selectedElementToUpdate
            ? _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dense: "" } },
                    [
                      _c("v-toolbar-title", [_vm._v(_vm._s(_vm.ModalTitle))]),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-card-title", { staticClass: "justify-center" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.selectedElementToUpdate.sigma) +
                        " - " +
                        _vm._s(_vm.selectedElementToUpdate.name) +
                        " - VL " +
                        _vm._s(
                          _vm.selectedElementToUpdate.logisticVariantCode
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-simple-table", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th"),
                                          _c(
                                            "th",
                                            { staticClass: "text-center" },
                                            [_vm._v(" Qté en stock ")]
                                          ),
                                          _c(
                                            "th",
                                            { staticClass: "text-center" },
                                            [_vm._v(" Qté bloquée ")]
                                          ),
                                          _c(
                                            "th",
                                            { staticClass: "text-center" },
                                            [
                                              _vm.blockingType === "B"
                                                ? _c("div", [
                                                    _vm._v(" Qté à bloquer ")
                                                  ])
                                                : _c("div", [
                                                    _vm._v(" Qté à débloquer ")
                                                  ])
                                            ]
                                          )
                                        ])
                                      ]),
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("td", [_vm._v("Colis")]),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedElementToUpdate
                                                      .parcelTotalNumber
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedElementToUpdate
                                                      .blockedParcelTotalNumber
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  dense: "",
                                                  type: "number",
                                                  solo: "",
                                                  "hide-details": ""
                                                },
                                                on: {
                                                  blur: _vm.calculateValue
                                                },
                                                model: {
                                                  value: _vm.colSai,
                                                  callback: function($$v) {
                                                    _vm.colSai = $$v
                                                  },
                                                  expression: "colSai"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]),
                                        _c("tr", [
                                          _c("td", [_vm._v("UVC")]),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedElementToUpdate
                                                      .csuTotalNumber
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedElementToUpdate
                                                      .blockedCSUTotalNumber
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  dense: "",
                                                  type: "number",
                                                  solo: "",
                                                  "hide-details": ""
                                                },
                                                model: {
                                                  value: _vm.uvcSai,
                                                  callback: function($$v) {
                                                    _vm.uvcSai = $$v
                                                  },
                                                  expression: "uvcSai"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]),
                                        _c("tr", [
                                          _c("td", [_vm._v("Poids net")]),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedElementToUpdate
                                                      .netWeightTotal
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedElementToUpdate
                                                      .blockedNetWeightTotal
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  dense: "",
                                                  type: "decimal",
                                                  solo: "",
                                                  "hide-details": ""
                                                },
                                                model: {
                                                  value: _vm.netSai,
                                                  callback: function($$v) {
                                                    _vm.netSai = $$v
                                                  },
                                                  expression: "netSai"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3190971878
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            outlined: "",
                            disabled: _vm.canValidateVl
                          },
                          on: { click: _vm.validate_VL }
                        },
                        [_vm._v(" Valider ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", outlined: "" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v(" Annuler ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: "error darken-1",
            "multi-line": true,
            right: true,
            timeout: "-1",
            vertical: true,
            top: true
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function(ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { dark: "", text: "" },
                        on: {
                          click: function($event) {
                            _vm.errorNotif = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.errorNotif,
            callback: function($$v) {
              _vm.errorNotif = $$v
            },
            expression: "errorNotif"
          }
        },
        [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: "success darken-1",
            "multi-line": true,
            right: true,
            timeout: "1000",
            top: true,
            vertical: true
          },
          model: {
            value: _vm.successNotif,
            callback: function($$v) {
              _vm.successNotif = $$v
            },
            expression: "successNotif"
          }
        },
        [_vm._v(" " + _vm._s(_vm.successMessage) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }